<template>
  <div class="solutionCase">
    <top-nav></top-nav>
    <banner :bgImage="bgImage"></banner>
    <section class="clientVoice">
      <div class="solutionCaseBox" style="padding-bottom: 0">
        <div class="solutionConceptBox">
          <div class="solutionConceptBoxR">
            <img src="../../../static/images/clientConceptPic1.jpg" />
          </div>
          <div class="solutionConceptBoxL clientCaseBlue">
            <div class="solutionConceptIn">
              <div class="solutionConceptInTit">用心聆听客户的声音</div>
              <div class="solutionConceptInConn">
                长期以来，公共数据和电子政务多头管理、各自为政，带来了数据壁垒、服务碎片和安全脆弱等弊病，给老百姓办事带来障碍。针对这些难点和痛点问题，睿哲科技提供了跟我们非常匹配的智慧政务解决方案，恰到好处地解决了我们目前的困境。
                <p>——某市发展和改革委员会</p>
              </div>
            </div>
            <div class="clientCaseArr"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="clientIncome">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          注重客户收益，想客户之所想
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <img src="../../../static/images/solutionDetailIcon05.png" />
            <div class="solutionIncomeConn">
              实现政府各类<br />公共资源的充分共享
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon06.png" />
            <div class="solutionIncomeConn">
              解决政府各委办局<br />“信息孤岛”问题
            </div>
          </li>
          <li>
            <img src="../../../static/images/solutionDetailIcon07.png" />
            <div class="solutionIncomeConn">
              提升智慧政务网站及<br />应用信息安全的保障级别
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="clientChallenge">
      <div class="clientChallengeBox">
        <img src="../../../static/images/clientChallengeBg1.jpg" />
        <div class="clientChallengeConn">
          <div class="clientChallengeTit">直面挑战，毫不畏惧</div>
          <ul class="clientChallengeList">
            <li>
              <span><i></i></span
              >建设全新兼容支持新旧（IPv4和IPv6）的智慧政务信息化系统
            </li>
            <li>
              <span><i></i></span>解决各委办局“信息孤岛”问题
            </li>
            <li>
              <span><i></i></span>快速实现政府各类公共资源充分共享
            </li>
            <li>
              <span><i></i></span>全面支持新旧系统的数据灵活调用和分析精准度
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="clientSolution">
      <div class="solutionCaseBox">
        <div class="solutionCaseTit clientCaseFont">
          成熟的解决方案，难题迎刃而解
        </div>
        <ul class="solutionIncomeFlex">
          <li>
            <div class="clientSolutionTit">
              平滑过渡<br /><span>SPACE6技术架构</span>
            </div>
            <div class="clientSolutionConn">
              采用SPACE6技术架构，融合了应用层多协议翻译和网络层翻译技术，同时从应用层和网络层对IPv4/IPv6协议进行转换，实现IPv4/IPv6平滑过渡
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">
              易管易维<br /><span>简易管理模式</span>
            </div>
            <div class="clientSolutionConn">
              具有图形化和命令行等多种管理模式，可以通过统一的网络管理界面，管理所有6ATE设备，实现系统状态监测、故障管理、配置管理、日志管理、统计分析等多项功能
            </div>
          </li>
          <li>
            <div class="clientSolutionTit">
              协同工作<br /><span>SOCS架构</span>
            </div>
            <div class="clientSolutionConn">
              采用SOCS架构，可以由单台或多台设备组成，每台设备完全等价，彼此自动发现和协同工作，在实现高可靠性的同时极大提升了设备的扩展能力
            </div>
          </li>
        </ul>
      </div>
    </section>
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from "@/components/topNav";
import bottomFooter from "@/components/bottomFooter.vue";
import banner from "@/components/banner.vue";

export default {
  name: "solutionCase",
  data() {
    return {
      bgImage: "../../../static/images/clientDetailBanner.jpg?0219",
      showMask: false,
    };
  },

  components: {
    topNav,
    bottomFooter,
    banner,
  },

  computed: {},

  mounted() {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../assets/css/global";
@import "./case";
.solutionCase {
}
</style>



// WEBPACK FOOTER //
// src/pages/case/caseDetail1.vue